import styled from 'styled-components';
import { themed } from '@/shared/ui/core';

export const ShiftContact = styled.div`
  align-items: center;
  display: flex;
  padding-top: 0.5rem;

  .Text {
    font-size: 0.75rem;
    margin-left: 0.5rem;
  }
`;

export const IconWrapper = styled.div`
  width: 1.25rem;

  svg {
    display: block;
  }
`;

export const Link = styled.a`
  color: ${themed('primary.accent')};
  font-size: 0.75rem;
  font-weight: 600;
  margin-left: 1rem;
  text-decoration: underline;
`;
